<template>
  <div>
    <div v-if="!loading">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-popover placement="bottom" width="400" trigger="click">
            <div>Review Timeline</div>
            <el-table :data="project.reviewTimeLine">
              <el-table-column width="40" prop="id" label="">
                <template slot-scope="scope">
                  <i v-if="scope.row.description === 'Completed'" style="color: #7cbe5f; font-size: 18px;" class="mdi mdi-check-bold"></i>
                  <i v-if="scope.row.description !== 'Completed'" style="color: rgba(236, 0, 140, 0.8); font-size: 20px;" class="mdi mdi-clock-alert-outline"></i>
                </template>
              </el-table-column>
              <el-table-column width="170" prop="item" label="Item"></el-table-column>
              <el-table-column prop="description" label="Description"></el-table-column>
              <el-table-column prop="date" label="Date"></el-table-column>
            </el-table>
            <el-button slot="reference" title="Review Timeline" class="reviewTimeline" plain v-if="checkReviewTimelineDataStatus(project.reviewTimeLine, 'Preliminary')"
              icon="el-icon-warning" type="warning">Preliminary</el-button>

            <el-button slot="reference" title="Review Timeline" v-if="checkReviewTimelineDataStatus(project.reviewTimeLine, 'Final')" class="reviewTimeline"
              icon="el-icon-success" type="success">Final</el-button>
          </el-popover>
          <!-- </el-form-item> -->
          <span class="stats">
            <el-badge v-for="stat in compProjectStatistics" :key="stat.key" class="item" :class="{ 'stats-loading': statsLoading }" :value="stat.count">
              <el-tag type="primary" size="small">{{ stat.key }}</el-tag>
            </el-badge>
          </span>
        </el-col>
      </el-row>
    </div>
    <!-- <small style="font-size:12px;" class="pull-right"><i data-v-b11e00d8="">*statistics are based on records with changes</i></small> -->
    <!-- <el-form style="margin: 0px 0px 20px 0px;" class="myProjects" v-if="!loading" size="mini" label-position="left" label-width="130px"> </el-form> -->
  </div>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields'
  import { mapState } from 'vuex'

  const { mapFields } = createHelpers({
    getterType: 'myProjects/getField',
    mutationType: 'myProjects/updateField'
  })

  export default {
    name: 'coderProjectHeader',
    props: ['loading', 'projectStatistics'],
    mixins: [],
    data() {
      return {
        statsLoading: false,
        showTimeLinePopover: false
      }
    },
    components: {},
    mounted: function () { },
    created: function () { },
    methods: {
      test() {
        this.showTimeLinePopover = true
      },
      checkReviewTimelineDataStatus(reviewTimeLine, key) {
        if (reviewTimeLine.length) {
          return reviewTimeLine[0].dataStatus === key
        }
        return false
      }
    },
    computed: {
      ...mapState('myProjects/', ['ipListStatistics', 'opListStatistics', 'proListStatistics', 'ambListStatistics']),
      ...mapState('reports/', ['reports']),
      ...mapState('dropdowns/', ['dropdowns']),
      ...mapState('myProjects/', ['project', 'projectLoading', 'drgTableIds', 'proRecordIds', 'ascTableIds', 'ipList', 'opList', 'ambList', 'proList']),
      ...mapFields(['project.clientId', 'project.startDate', 'project.endDate', 'project.identifierId', 'project.coderId', 'project.id', 'project.projectID', 'project.projectTypeId', 'project.leadId', 'project.identifierSelectionsArray', 'project.identifierSelections', 'project.defaultCodeType', 'project.description', 'project.outpatientGrouperId', 'project.projectColor', 'project.projectStatusId', 'project.coderReviewedDate', 'project.providerReviewedDate', 'project.responseCompleteDate']),
      compProjectStatistics() {
        if (this.projectStatistics === 'ip') {
          return this.ipListStatistics
        }
        if (this.projectStatistics === 'op') {
          return this.opListStatistics
        }
        if (this.projectStatistics === 'pro') {
          return this.proListStatistics
        }
        if (this.projectStatistics === 'amb') {
          return this.ambListStatistics
        }
        return {}
      }
    },
    watch: {}
  }
</script>

<style scoped>
  >>>.reviewTimeline {
    margin-top: 3px;
    padding: 4px 0px 4px 0px;
    width: 100px;
    margin-right: 25px;
    float: left;
    border-radius: 20px;
    height: 25px;
  }

  >>>.reviewTimeline .el-icon-warning,
  >>>.reviewTimeline .el-icon-success {
    font-size: 15px;
    margin-left: 5px;
    float: left;
  }

  >>>.reviewTimeline span {
    float: left;
    margin: 2px 0px 0px 5px;
  }

  >>>.reviewTimeline.el-button--warning:hover span,
  >>>.reviewTimeline.el-button--warning:focus span {
    color: #e6a23c;
  }

  >>>.reviewTimeline:hover .el-icon-warning,
  >>>.reviewTimeline:focus .el-icon-warning {
    color: #e6a23c;
  }

  >>>.reviewTimeline.el-button--success span {
    color: #7cbe5f;
  }

  >>>.reviewTimeline .el-icon-success {
    color: #7cbe5f;
  }

  >>>.reviewTimeline:hover .el-icon-success,
  >>>.reviewTimeline:focus .el-icon-success {
    color: #7cbe5f;
  }

  /* .reviewTimeline {
  background-color: transparent !important;
  margin-top: 3px;
}

.reviewTimeline .el-alert__icon {
  font-size: 15px;
  width: 15px;
  margin-left: 1px;
}

.reviewTimeline .el-alert__content:hover {
  text-decoration: underline;
} */

  .item {
    margin-top: 3px;
    margin-right: 35px;
    margin-bottom: 10px;
  }

  .stats-loading {
    opacity: 0.5;
  }

  .stats .el-tag {
    background-color: transparent !important;
    color: #909399 !important;
    border-color: #e9e9eb !important;
  }

  .stats>>>.el-badge__content {
    background-color: #f4f4f5 !important;
    color: #303133 !important;
  }
</style>
